import { render, staticRenderFns } from "./AccountBalanceInfo.vue?vue&type=template&id=28985c86&scoped=true&"
import script from "./AccountBalanceInfo.vue?vue&type=script&lang=js&"
export * from "./AccountBalanceInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccountBalanceInfo.vue?vue&type=style&index=0&id=28985c86&prod&lang=css&"
import style1 from "./AccountBalanceInfo.vue?vue&type=style&index=1&id=28985c86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28985c86",
  null
  
)

export default component.exports